import script from "./PayrollCalc.vue?vue&type=script&setup=true&lang=js"
export * from "./PayrollCalc.vue?vue&type=script&setup=true&lang=js"

import "./PayrollCalc.vue?vue&type=style&index=0&id=2a669858&lang=css"

const __exports__ = script;

export default __exports__